<template>
  <div>
    <!-- Bold button -->
    <button class="ql-bold">Bold</button>
    <button class="ql-italic">Italic</button>
    <button class="ql-underline">Underline</button>
    <button class="ql-strike">Strike</button>
    <button class="ql-blockquote">Blockquote</button>
    <button class="ql-list" value="ordered">Ordered List</button>
    <button class="ql-list" value="bullet">Bullet List</button>
    <button class="ql-indent" value="+1">Indent</button>
    <button class="ql-indent" value="-1">Outdent</button>
    <button class="ql-align" value="">Left</button>
    <button class="ql-align" value="center">Center</button>
    <button class="ql-align" value="right">Right</button>
    <button class="ql-align" value="justify">Justify</button>

    <!-- Font Size dropdown -->
    <select class="ql-size">
      <option value="small">Small</option>
      <option selected>Normal</option>
      <option value="large">Large</option>
      <option value="huge">Huge</option>
    </select>

    <!-- Text Color picker -->
    <button class="ql-color">Text Color</button>
    <!-- Link button -->
    <button class="ql-link">Link</button>
    <!-- Video button -->
    <button class="ql-video">Video</button>
    <button class="ql-blockquote">blockquote</button>

  </div>
</template>

<script>
export default {
  name: 'EditorToolbar',
}
</script>
